// @ts-nocheck
import { createStyle } from '@gluestack-style/react';
import { BaseIconVariants } from './Icon';

export const TabsTabIcon = createStyle({
  variants: BaseIconVariants,
  props: {
    size: 'md',
  },
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  mr: 12,
});
